// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicCommonGetV2PublicAnnoucements (params?: {}): Promise<Dict>;
    publicCommonGetV2PublicTime (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1NoticeQueryAllNotices (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicTime (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicCurrencies (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicProducts (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicProduct (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketTicker (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketTickers (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketFills (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketFillsHistory (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketCandles (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketDepth (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketSpotVipLevel (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketMergeDepth (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1MarketHistoryCandles (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicLoanCoinInfos (params?: {}): Promise<Dict>;
    publicSpotGetSpotV1PublicLoanHourInterest (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotPublicCoins (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotPublicSymbols (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketVipFeeRate (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketTickers (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketMergeDepth (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketOrderbook (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketCandles (params?: {}): Promise<Dict | List | string>;
    publicSpotGetV2SpotMarketHistoryCandles (params?: {}): Promise<Dict | List | string>;
    publicSpotGetV2SpotMarketFills (params?: {}): Promise<Dict>;
    publicSpotGetV2SpotMarketFillsHistory (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketContracts (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketDepth (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketTicker (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketTickers (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketContractVipLevel (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketFills (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketFillsHistory (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketCandles (params?: {}): Promise<List>;
    publicMixGetMixV1MarketIndex (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketFundingTime (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketHistoryFundRate (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketCurrentFundRate (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketOpenInterest (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketMarkPrice (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketSymbolLeverage (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketQueryPositionLever (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketOpenLimit (params?: {}): Promise<Dict>;
    publicMixGetMixV1MarketHistoryCandles (params?: {}): Promise<List>;
    publicMixGetMixV1MarketHistoryIndexCandles (params?: {}): Promise<List>;
    publicMixGetMixV1MarketHistoryMarkCandles (params?: {}): Promise<List>;
    publicMixGetMixV1MarketMergeDepth (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketVipFeeRate (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketUnionInterestRateHistory (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketExchangeRate (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketDiscountRate (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketMergeDepth (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketTicker (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketTickers (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketFills (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketFillsHistory (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketCandles (params?: {}): Promise<Dict | List | string>;
    publicMixGetV2MixMarketHistoryCandles (params?: {}): Promise<Dict | List | string>;
    publicMixGetV2MixMarketHistoryIndexCandles (params?: {}): Promise<Dict | List | string>;
    publicMixGetV2MixMarketHistoryMarkCandles (params?: {}): Promise<Dict | List | string>;
    publicMixGetV2MixMarketOpenInterest (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketFundingTime (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketSymbolPrice (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketHistoryFundRate (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketCurrentFundRate (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketOiLimit (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketContracts (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketQueryPositionLever (params?: {}): Promise<Dict>;
    publicMixGetV2MixMarketAccountLongShort (params?: {}): Promise<Dict>;
    publicMarginGetMarginV1CrossPublicInterestRateAndLimit (params?: {}): Promise<Dict>;
    publicMarginGetMarginV1IsolatedPublicInterestRateAndLimit (params?: {}): Promise<Dict>;
    publicMarginGetMarginV1CrossPublicTierData (params?: {}): Promise<Dict>;
    publicMarginGetMarginV1IsolatedPublicTierData (params?: {}): Promise<Dict>;
    publicMarginGetMarginV1PublicCurrencies (params?: {}): Promise<Dict>;
    publicMarginGetV2MarginCurrencies (params?: {}): Promise<Dict>;
    publicMarginGetV2MarginMarketLongShortRatio (params?: {}): Promise<Dict>;
    publicEarnGetV2EarnLoanPublicCoinInfos (params?: {}): Promise<Dict>;
    publicEarnGetV2EarnLoanPublicHourInterest (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketInstruments (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketTickers (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketOrderbook (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketFills (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketProofOfReserves (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketOpenInterest (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketCandles (params?: {}): Promise<Dict | List | string>;
    publicUtaGetV3MarketHistoryCandles (params?: {}): Promise<Dict | List | string>;
    publicUtaGetV3MarketCurrentFundRate (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketHistoryFundRate (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketRiskReserve (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketDiscountRate (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketMarginLoans (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketPositionTier (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketOiLimit (params?: {}): Promise<Dict>;
    publicUtaGetV3MarketIndexComponents (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1WalletDepositAddress (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1WalletWithdrawalList (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1WalletDepositList (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1AccountGetInfo (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1AccountAssets (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1AccountAssetsLite (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1AccountTransferRecords (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1ConvertCurrencies (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1ConvertConvertRecord (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1LoanOngoingOrders (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1LoanRepayHistory (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1LoanReviseHistory (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1LoanBorrowHistory (params?: {}): Promise<Dict>;
    privateSpotGetSpotV1LoanDebts (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeOrderInfo (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeUnfilledOrders (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeHistoryOrders (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeFills (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeCurrentPlanOrder (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotTradeHistoryPlanOrder (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountInfo (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountAssets (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountSubaccountAssets (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountBills (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountTransferRecords (params?: {}): Promise<Dict>;
    privateSpotGetV2AccountFundingAssets (params?: {}): Promise<Dict>;
    privateSpotGetV2AccountBotAssets (params?: {}): Promise<Dict>;
    privateSpotGetV2AccountAllAccountBalance (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotWalletDepositAddress (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotWalletDepositRecords (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotWalletWithdrawalRecords (params?: {}): Promise<Dict>;
    privateSpotGetV2SpotAccountUpgradeStatus (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletTransfer (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletTransferV2 (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletSubTransfer (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletWithdrawal (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletWithdrawalV2 (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletWithdrawalInner (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1WalletWithdrawalInnerV2 (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1AccountSubAccountSpotAssets (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1AccountBills (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeOrders (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeBatchOrders (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeCancelOrder (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeCancelOrderV2 (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeCancelSymbolOrder (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeCancelBatchOrders (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeCancelBatchOrdersV2 (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeOrderInfo (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeOpenOrders (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeHistory (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TradeFills (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanPlacePlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanModifyPlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanCancelPlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanCurrentPlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanHistoryPlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1PlanBatchCancelPlan (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1ConvertQuotedPrice (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1ConvertTrade (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1LoanBorrow (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1LoanRepay (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1LoanRevisePledge (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderOrderCurrentList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderOrderHistoryList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderCloseTrackingOrder (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderUpdateTpsl (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderFollowerEndOrder (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceOrderSpotInfoList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceConfigGetTraderSettings (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceConfigGetFollowerSettings (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceUserMyTraders (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceConfigSetFollowerConfig (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceUserMyFollowers (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceConfigSetProductCode (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceUserRemoveTrader (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceGetRemovableFollower (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceUserRemoveFollower (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceProfitTotalProfitInfo (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceProfitTotalProfitList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceProfitProfitHisList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceProfitProfitHisDetailList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceProfitWaitProfitDetailList (params?: {}): Promise<Dict>;
    privateSpotPostSpotV1TraceUserGetTraderInfo (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradePlaceOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeCancelOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeBatchOrders (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeBatchCancelOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeCancelSymbolOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradePlacePlanOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeModifyPlanOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeCancelPlanOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeCancelReplaceOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotTradeBatchCancelPlanOrder (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotWalletTransfer (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotWalletSubaccountTransfer (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotWalletWithdrawal (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotWalletCancelWithdrawal (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotWalletModifyDepositAccount (params?: {}): Promise<Dict>;
    privateSpotPostV2SpotAccountUpgrade (params?: {}): Promise<Dict>;
    privateMixGetMixV1AccountAccount (params?: {}): Promise<Dict>;
    privateMixGetMixV1AccountAccounts (params?: {}): Promise<Dict>;
    privateMixGetMixV1PositionSinglePosition (params?: {}): Promise<Dict>;
    privateMixGetMixV1PositionSinglePositionV2 (params?: {}): Promise<Dict>;
    privateMixGetMixV1PositionAllPosition (params?: {}): Promise<Dict>;
    privateMixGetMixV1PositionAllPositionV2 (params?: {}): Promise<Dict>;
    privateMixGetMixV1PositionHistoryPosition (params?: {}): Promise<Dict>;
    privateMixGetMixV1AccountAccountBill (params?: {}): Promise<Dict>;
    privateMixGetMixV1AccountAccountBusinessBill (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderCurrent (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderMarginCoinCurrent (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderHistory (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderHistoryProductType (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderDetail (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderFills (params?: {}): Promise<Dict>;
    privateMixGetMixV1OrderAllFills (params?: {}): Promise<Dict>;
    privateMixGetMixV1PlanCurrentPlan (params?: {}): Promise<Dict>;
    privateMixGetMixV1PlanHistoryPlan (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceCurrentTrack (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceFollowerOrder (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceFollowerHistoryOrders (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceHistoryTrack (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceSummary (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceProfitSettleTokenIdGroup (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceProfitDateGroupList (params?: {}): Promise<Dict>;
    privateMixGetMixV1TradeProfitDateList (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceWaitProfitDateList (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceTraderSymbols (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceTraderList (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceTraderDetail (params?: {}): Promise<Dict>;
    privateMixGetMixV1TraceQueryTraceConfig (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountAccount (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountAccounts (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountSubAccountAssets (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountInterestHistory (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountMaxOpen (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountLiqPrice (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountOpenCount (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountBill (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountTransferLimits (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountUnionConfig (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountSwitchUnionUsdt (params?: {}): Promise<Dict>;
    privateMixGetV2MixAccountIsolatedSymbols (params?: {}): Promise<Dict>;
    privateMixGetV2MixMarketQueryPositionLever (params?: {}): Promise<Dict>;
    privateMixGetV2MixPositionSinglePosition (params?: {}): Promise<Dict>;
    privateMixGetV2MixPositionAllPosition (params?: {}): Promise<Dict>;
    privateMixGetV2MixPositionAdlRank (params?: {}): Promise<Dict>;
    privateMixGetV2MixPositionHistoryPosition (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderDetail (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderFills (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderFillHistory (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderOrdersPending (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderOrdersHistory (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderPlanSubOrder (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderOrdersPlanPending (params?: {}): Promise<Dict>;
    privateMixGetV2MixOrderOrdersPlanHistory (params?: {}): Promise<Dict>;
    privateMixGetV2MixMarketPositionLongShort (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountSubAccountContractAssets (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountOpenCount (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountSetLeverage (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountSetMargin (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountSetMarginMode (params?: {}): Promise<Dict>;
    privateMixPostMixV1AccountSetPositionMode (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderPlaceOrder (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderBatchOrders (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderCancelOrder (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderCancelBatchOrders (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderModifyOrder (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderCancelSymbolOrders (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderCancelAllOrders (params?: {}): Promise<Dict>;
    privateMixPostMixV1OrderCloseAllPositions (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanPlacePlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanModifyPlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanModifyPlanPreset (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanPlaceTPSL (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanPlaceTrailStop (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanPlacePositionsTPSL (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanModifyTPSLPlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanCancelPlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanCancelSymbolPlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1PlanCancelAllPlan (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceCloseTrackOrder (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceModifyTPSL (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceCloseTrackOrderBySymbol (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceSetUpCopySymbols (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceFollowerSetBatchTraceConfig (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceFollowerCloseByTrackingNo (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceFollowerCloseByAll (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceFollowerSetTpsl (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceCancelCopyTrader (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceTraderUpdateConfig (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceMyTraderList (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceMyFollowerList (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceRemoveFollower (params?: {}): Promise<Dict>;
    privateMixPostMixV1TracePublicGetFollowerConfig (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceReportOrderHistoryList (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceReportOrderCurrentList (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceQueryTraderTpslRatioConfig (params?: {}): Promise<Dict>;
    privateMixPostMixV1TraceTraderUpdateTpslRatioConfig (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetAutoMargin (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetLeverage (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetAllLeverage (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetMargin (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetAssetMode (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetMarginMode (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountUnionConvert (params?: {}): Promise<Dict>;
    privateMixPostV2MixAccountSetPositionMode (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderPlaceOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderClickBackhand (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderBatchPlaceOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderModifyOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderCancelOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderBatchCancelOrders (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderClosePositions (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderCancelAllOrders (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderPlaceTpslOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderPlacePosTpsl (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderPlacePlanOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderModifyTpslOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderModifyPlanOrder (params?: {}): Promise<Dict>;
    privateMixPostV2MixOrderCancelPlanOrder (params?: {}): Promise<Dict>;
    privateUserGetUserV1FeeQuery (params?: {}): Promise<Dict>;
    privateUserGetUserV1SubVirtualList (params?: {}): Promise<Dict>;
    privateUserGetUserV1SubVirtualApiList (params?: {}): Promise<Dict>;
    privateUserGetUserV1TaxSpotRecord (params?: {}): Promise<Dict>;
    privateUserGetUserV1TaxFutureRecord (params?: {}): Promise<Dict>;
    privateUserGetUserV1TaxMarginRecord (params?: {}): Promise<Dict>;
    privateUserGetUserV1TaxP2pRecord (params?: {}): Promise<Dict>;
    privateUserGetV2UserVirtualSubaccountList (params?: {}): Promise<Dict>;
    privateUserGetV2UserVirtualSubaccountApikeyList (params?: {}): Promise<Dict>;
    privateUserPostUserV1SubVirtualCreate (params?: {}): Promise<Dict>;
    privateUserPostUserV1SubVirtualModify (params?: {}): Promise<Dict>;
    privateUserPostUserV1SubVirtualApiBatchCreate (params?: {}): Promise<Dict>;
    privateUserPostUserV1SubVirtualApiCreate (params?: {}): Promise<Dict>;
    privateUserPostUserV1SubVirtualApiModify (params?: {}): Promise<Dict>;
    privateUserPostV2UserCreateVirtualSubaccount (params?: {}): Promise<Dict>;
    privateUserPostV2UserModifyVirtualSubaccount (params?: {}): Promise<Dict>;
    privateUserPostV2UserBatchCreateSubaccountAndApikey (params?: {}): Promise<Dict>;
    privateUserPostV2UserCreateVirtualSubaccountApikey (params?: {}): Promise<Dict>;
    privateUserPostV2UserModifyVirtualSubaccountApikey (params?: {}): Promise<Dict>;
    privateP2pGetP2pV1MerchantMerchantList (params?: {}): Promise<Dict>;
    privateP2pGetP2pV1MerchantMerchantInfo (params?: {}): Promise<Dict>;
    privateP2pGetP2pV1MerchantAdvList (params?: {}): Promise<Dict>;
    privateP2pGetP2pV1MerchantOrderList (params?: {}): Promise<Dict>;
    privateP2pGetV2P2pMerchantList (params?: {}): Promise<Dict>;
    privateP2pGetV2P2pMerchantInfo (params?: {}): Promise<Dict>;
    privateP2pGetV2P2pOrderList (params?: {}): Promise<Dict>;
    privateP2pGetV2P2pAdvList (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountInfo (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubList (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubEmail (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubSpotAssets (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubFutureAssets (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubaccountTransfer (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubaccountDeposit (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubaccountWithdrawal (params?: {}): Promise<Dict>;
    privateBrokerGetBrokerV1AccountSubApiList (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerAccountInfo (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerAccountSubaccountList (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerAccountSubaccountEmail (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerAccountSubaccountSpotAssets (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerAccountSubaccountFutureAssets (params?: {}): Promise<Dict>;
    privateBrokerGetV2BrokerManageSubaccountApikeyList (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubCreate (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubModify (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubModifyEmail (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubAddress (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubWithdrawal (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubAutoTransfer (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubApiCreate (params?: {}): Promise<Dict>;
    privateBrokerPostBrokerV1AccountSubApiModify (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountModifySubaccountEmail (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountCreateSubaccount (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountModifySubaccount (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountSubaccountAddress (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountSubaccountWithdrawal (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerAccountSetSubaccountAutotransfer (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerManageCreateSubaccountApikey (params?: {}): Promise<Dict>;
    privateBrokerPostV2BrokerManageModifySubaccountApikey (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossAccountRiskRate (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossAccountMaxTransferOutAmount (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedAccountMaxTransferOutAmount (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedOrderOpenOrders (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedOrderHistory (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedOrderFills (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedLoanList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedRepayList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedInterestList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedLiquidationList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedFinList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossOrderOpenOrders (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossOrderHistory (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossOrderFills (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossLoanList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossRepayList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossInterestList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossLiquidationList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossFinList (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1CrossAccountAssets (params?: {}): Promise<Dict>;
    privateMarginGetMarginV1IsolatedAccountAssets (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedBorrowHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedRepayHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedInterestHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedLiquidationHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedFinancialRecords (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedAccountAssets (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedAccountRiskRate (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedAccountMaxBorrowableAmount (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedAccountMaxTransferOutAmount (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedInterestRateAndLimit (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedTierData (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedOpenOrders (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedHistoryOrders (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginCrossedFills (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedBorrowHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedRepayHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedInterestHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedLiquidationHistory (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedFinancialRecords (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedAccountAssets (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedAccountRiskRate (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedAccountMaxBorrowableAmount (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedAccountMaxTransferOutAmount (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedInterestRateAndLimit (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedTierData (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedOpenOrders (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedHistoryOrders (params?: {}): Promise<Dict>;
    privateMarginGetV2MarginIsolatedFills (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossAccountBorrow (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountBorrow (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossAccountRepay (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountRepay (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountRiskRate (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossAccountMaxBorrowableAmount (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountMaxBorrowableAmount (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountFlashRepay (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedAccountQueryFlashRepayStatus (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossAccountFlashRepay (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossAccountQueryFlashRepayStatus (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedOrderPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedOrderBatchPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedOrderCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1IsolatedOrderBatchCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossOrderPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossOrderBatchPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossOrderCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostMarginV1CrossOrderBatchCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedAccountBorrow (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedAccountRepay (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedAccountFlashRepay (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedAccountQueryFlashRepayStatus (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedBatchPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginCrossedBatchCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedAccountBorrow (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedAccountRepay (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedAccountFlashRepay (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedAccountQueryFlashRepayStatus (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedBatchPlaceOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedCancelOrder (params?: {}): Promise<Dict>;
    privateMarginPostV2MarginIsolatedBatchCancelOrder (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderOrderCurrentTrack (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderOrderHistoryTrack (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderOrderTotalDetail (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderProfitHistorySummarys (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderProfitHistoryDetails (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderProfitDetails (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderProfitsGroupCoinDate (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderConfigQuerySymbols (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixTraderConfigQueryFollowers (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixFollowerQueryCurrentOrders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixFollowerQueryHistoryOrders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixFollowerQuerySettings (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixFollowerQueryTraders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixFollowerQueryQuantityLimit (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixBrokerQueryTraders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixBrokerQueryHistoryTraces (params?: {}): Promise<Dict>;
    privateCopyGetV2CopyMixBrokerQueryCurrentTraces (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderProfitSummarys (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderProfitHistoryDetails (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderProfitDetails (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderOrderTotalDetail (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderOrderHistoryTrack (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderOrderCurrentTrack (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderConfigQuerySettings (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotTraderConfigQueryFollowers (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotFollowerQueryTraders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotFollowerQueryTraderSymbols (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotFollowerQuerySettings (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotFollowerQueryHistoryOrders (params?: {}): Promise<Dict>;
    privateCopyGetV2CopySpotFollowerQueryCurrentOrders (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixTraderOrderModifyTpsl (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixTraderOrderClosePositions (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixTraderConfigSettingSymbols (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixTraderConfigSettingBase (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixTraderConfigRemoveFollower (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixFollowerSettingTpsl (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixFollowerSettings (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixFollowerClosePositions (params?: {}): Promise<Dict>;
    privateCopyPostV2CopyMixFollowerCancelTrader (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotTraderOrderModifyTpsl (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotTraderOrderCloseTracking (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotTraderConfigSettingSymbols (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotTraderConfigRemoveFollower (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotFollowerStopOrder (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotFollowerSettings (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotFollowerSettingTpsl (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotFollowerOrderCloseTracking (params?: {}): Promise<Dict>;
    privateCopyPostV2CopySpotFollowerCancelTrader (params?: {}): Promise<Dict>;
    privateTaxGetV2TaxSpotRecord (params?: {}): Promise<Dict>;
    privateTaxGetV2TaxFutureRecord (params?: {}): Promise<Dict>;
    privateTaxGetV2TaxMarginRecord (params?: {}): Promise<Dict>;
    privateTaxGetV2TaxP2pRecord (params?: {}): Promise<Dict>;
    privateConvertGetV2ConvertCurrencies (params?: {}): Promise<Dict>;
    privateConvertGetV2ConvertQuotedPrice (params?: {}): Promise<Dict>;
    privateConvertGetV2ConvertConvertRecord (params?: {}): Promise<Dict>;
    privateConvertGetV2ConvertBgbConvertCoinList (params?: {}): Promise<Dict>;
    privateConvertGetV2ConvertBgbConvertRecords (params?: {}): Promise<Dict>;
    privateConvertPostV2ConvertTrade (params?: {}): Promise<Dict>;
    privateConvertPostV2ConvertBgbConvert (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsProduct (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsAccount (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsAssets (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsRecords (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsSubscribeInfo (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsSubscribeResult (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSavingsRedeemResult (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinProduct (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinAccount (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinAssets (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinRecords (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinSubscribeInfo (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnSharkfinSubscribeResult (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanOngoingOrders (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanRepayHistory (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanReviseHistory (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanBorrowHistory (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanDebts (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnLoanReduces (params?: {}): Promise<Dict>;
    privateEarnGetV2EarnAccountAssets (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnSavingsSubscribe (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnSavingsRedeem (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnSharkfinSubscribe (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnLoanBorrow (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnLoanRepay (params?: {}): Promise<Dict>;
    privateEarnPostV2EarnLoanRevisePledge (params?: {}): Promise<Dict>;
    privateCommonGetV2CommonTradeRate (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountAssets (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountFundingAssets (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSettings (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountFinancialRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountRepayableCoins (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountPaymentCoins (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountConvertRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountDeductInfo (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountFeeRate (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSwitchStatus (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountMaxTransferable (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountOpenInterestLimit (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSubUnifiedAssets (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountTransferableCoins (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSubTransferRecord (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountDepositAddress (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSubDepositAddress (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountDepositRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountSubDepositRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3AccountWithdrawalRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3BrokerSubList (params?: {}): Promise<Dict>;
    privateUtaGetV3BrokerAllSubDepositWithdrawal (params?: {}): Promise<Dict>;
    privateUtaGetV3BrokerCommission (params?: {}): Promise<Dict>;
    privateUtaGetV3BrokerQuerySubApikey (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanTransfered (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanSymbols (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanRiskUnit (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanRepaidHistory (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanProductInfos (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanLoanOrder (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanLtvConvert (params?: {}): Promise<Dict>;
    privateUtaGetV3InsLoanEnsureCoinsConvert (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanCoins (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanInterest (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanBorrowOngoing (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanBorrowHistory (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanRepayHistory (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanPledgeRateHistory (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanDebts (params?: {}): Promise<Dict>;
    privateUtaGetV3LoanReduces (params?: {}): Promise<Dict>;
    privateUtaGetV3PositionCurrentPosition (params?: {}): Promise<Dict>;
    privateUtaGetV3PositionHistoryPosition (params?: {}): Promise<Dict>;
    privateUtaGetV3PositionAdlRank (params?: {}): Promise<Dict>;
    privateUtaGetV3TaxRecords (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeOrderInfo (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeUnfilledOrders (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeUnfilledStrategyOrders (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeHistoryOrders (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeHistoryStrategyOrders (params?: {}): Promise<Dict>;
    privateUtaGetV3TradeFills (params?: {}): Promise<Dict>;
    privateUtaGetV3UserSubList (params?: {}): Promise<Dict>;
    privateUtaGetV3UserSubApiList (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSetLeverage (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSetHoldMode (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountRepay (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSwitchDeduct (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountDepositAccount (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSwitch (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountAdjustAccountMode (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountTransfer (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSubTransfer (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountSubMasterTransfer (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountMaxOpenAvailable (params?: {}): Promise<Dict>;
    privateUtaPostV3AccountWithdrawal (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerCreateSub (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerModifySub (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerSubWithdrawal (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerSubDepositAddress (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerCreateSubApikey (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerModifySubApikey (params?: {}): Promise<Dict>;
    privateUtaPostV3BrokerDeleteSubApikey (params?: {}): Promise<Dict>;
    privateUtaPostV3InsLoanBindUid (params?: {}): Promise<Dict>;
    privateUtaPostV3LoanBorrow (params?: {}): Promise<Dict>;
    privateUtaPostV3LoanRepay (params?: {}): Promise<Dict>;
    privateUtaPostV3LoanRevisePledge (params?: {}): Promise<Dict>;
    privateUtaPostV3TradePlaceOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradePlaceStrategyOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeModifyOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeModifyStrategyOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeCancelOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeCancelStrategyOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradePlaceBatch (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeBatchModifyOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeCancelBatch (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeCancelSymbolOrder (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeClosePositions (params?: {}): Promise<Dict>;
    privateUtaPostV3TradeCountdownCancelAll (params?: {}): Promise<Dict>;
    privateUtaPostV3UserCreateSub (params?: {}): Promise<Dict>;
    privateUtaPostV3UserFreezeSub (params?: {}): Promise<Dict>;
    privateUtaPostV3UserCreateSubApi (params?: {}): Promise<Dict>;
    privateUtaPostV3UserUpdateSubApi (params?: {}): Promise<Dict>;
    privateUtaPostV3UserDeleteSubApi (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
